







import { Component } from 'vue-property-decorator'
import { mixins } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'
import CurrentProductMixin from '../../../../mixins/CurrentProduct'

const products = namespace('products')

@Component({
  components: {
    OneProductDownload: () => import('~/components/organisms/product/OneProductDownload.vue'),
  },
})
export default class OneProductFilesSection extends mixins<CurrentProductMixin>(CurrentProductMixin) {
  @products.Getter getProductCertificates: any
  @products.Getter getProductDataSheets: any

  get showDownloadSection() {
    return (
      this.$product &&
      (this.getProductCertificates(this.$product?.id).length > 0 ||
        this.getProductDataSheets(this.$product?.id).length > 0)
    ) || false
  }
}
